import React, { PureComponent } from 'react'
import Icon from './../Icon'

class BigButton extends PureComponent {
  render () {
    return (
      <div onClick={this.props.showResults} className='bigbutton' >
        <Icon name={!this.props.toggle ? 'list' : 'map'} size="35" color="#649ed6" />
      </div>
    )
  }
}

export default BigButton


// WEBPACK FOOTER //
// ./src/components/parts/BigButton.js